templates =
  expandedCard: require '../coupon_card_expanded.html.mustache'
  sharing: require '../../multiple_offers/sharing.html.mustache'
  redemption:
    goBack: require '../redemption_go_back.html.mustache'
    onlinePromoCode: require '../redemption_online_promo_code.html.mustache'
    onlineSale: require '../redemption_online_sale.html.mustache'
    instorePromoCode: require '../redemption_instore_promo_code.html.mustache'
    instoreSale: require '../redemption_instore_sale.html.mustache'
    onlineAndInstore: require '../redemption_online_and_instore.html.mustache'
    mobileDownloadSale: require '../redemption_mobile_download_sale.html.mustache'

{getQueryStringByName} = require '../../helpers/frontend/query_string'

module.exports = class CouponCard

  constructor: (@el) ->
    @$el = $ @el
    @$description = @$el.find '.coupon-description'
    @$contentExpanded = @$el.find '.coupon-content-expanded'
    @$multipleOffers = $ '#multiple-offers'
    @isExpanded = false
    @coupon = @$el.data()
    @place = $('.mpp-container').data()
    @zeroClipboard = null

    @bindings()

    @checkQueryString()

  bindings: ->
    @$el.on 'click', @cardClick

    # Close this coupon card when the user opens another card.
    # This is not only for UX, but also necessary for ZeroClipboard to work properly.
    @$multipleOffers.on 'open-coupon', (event, couponId) =>
      return if couponId is @coupon.id
      @collapse() if @isExpanded

    @$el.find('.coupon-content-top').on 'click', =>
      return unless @isExpanded
      @collapse()

    @$el.on 'click', '.arrow-up', @collapse

    @$el.on 'click', '.use-online', =>
      @expand { useOnline: true }

    @$el.on 'click', '.use-instore', =>
      @expand { useInstore: true }

    @$el.on 'click', '.coupon-go-back', =>
      @expand()

  cardClick: =>
    return @open() unless @coupon.inPageFlow is true
    return if @isExpanded
    @$multipleOffers.trigger 'open-coupon', @coupon.id

    # The flow is like this:
    # - The first time a user opens a coupon, we open the affiliate link in the same page,
    # and then open a new tab with the same MPP, adding ?coupon_id=id (simulating a "pop under").
    # - For any other clicks after the first one, we check if we've already opened the affiliate link
    # and then we skip the simulated "pop under" and expand the card on the same page.

    affiliateUrl = @coupon.affiliateUrl
    return @expand() if not affiliateUrl? or @hasAlreadyOpenedAttributionLink()

    mppUrl = "#{window.location.protocol}//#{window.location.host}#{window.location.pathname}?coupon_id=#{@coupon.id}"

    @markAttributionLinkAsOpened()
    window.location = affiliateUrl
    window.open mppUrl

  getSessionStorageKey: ->
    "mpp-coupons-attribution-#{@place.placeId}"

  hasAlreadyOpenedAttributionLink: ->
    # checks if we've already opened the attribution link in the past hour during this session
    openTime = sessionStorage?.getItem @getSessionStorageKey()
    return false unless openTime? and openTime > 0
    diff = (new Date()).getTime() - openTime
    (60 * 60 * 1000) > diff

  markAttributionLinkAsOpened: ->
    sessionStorage?.setItem @getSessionStorageKey(), (new Date()).getTime()

  open: ->
    affiliateUrl = @coupon.affiliateUrl
    couponUrl = "#{@coupon.seeAllUrl}?c=#{@coupon.id}"

    if affiliateUrl?
      window.location = affiliateUrl
      window.open couponUrl
    else
      window.location = couponUrl

  expand: (options = {}) ->
    @isExpanded = true
    @$el.addClass 'is-expanded'
    @$description.removeClass 'should-truncate-singleline'

    showGoBack = false
    goBackOnline = false

    if options.useOnline is true
      if @coupon.promoCode?.length > 0
        redemptionTemplate = templates.redemption.onlinePromoCode
      else
        redemptionTemplate = templates.redemption.onlineSale
      showGoBack = true
      goBackOnline = true
    else if options.useInstore is true
      if @coupon.isSale
        redemptionTemplate = templates.redemption.instoreSale
      else
        redemptionTemplate = templates.redemption.instorePromoCode
      showGoBack = true
    else
      redemptionTemplate = switch @coupon.displayType
        when 'online_sale' then templates.redemption.onlineSale
        when 'instore_promo_code' then templates.redemption.instorePromoCode
        when 'instore_sale' then templates.redemption.instoreSale
        when 'online_instore_promo_code' then templates.redemption.onlineAndInstore
        when 'online_instore_sale' then templates.redemption.onlineAndInstore
        when 'mobile_download_sale' then templates.redemption.mobileDownloadSale
        else templates.redemption.onlinePromoCode

    basicTemplateData = {}
    basicTemplateData.translate = basicTemplateData.t = -> (text) -> I18n.translate text

    sharingTemplateData = _.extend basicTemplateData, { bhw: 'CouponSharing' }
    sharingHtml = templates.sharing.render sharingTemplateData

    if showGoBack
      goBackTemplateData = _.extend basicTemplateData, { goBackOnline }
      goBackHtml = templates.redemption.goBack.render goBackTemplateData

    afterCopyStrings =
      openBold: '<strong>'
      closeBold: '</strong>'
      openLink: "<a href=\"#{@coupon.affiliateUrl}\" target=\"_blank\">"
      closeLink: '</a>'

    redemptionTemplateData = _.extend basicTemplateData,
      goBackHtml: goBackHtml
      promoCode: @coupon.promoCode
      affiliateUrl: @coupon.affiliateUrl
      productImageUrl: "//#{@coupon.productImageUrl}"
      strings:
        afterCopy: I18n.translate 'js.modules.coupons.after_copy', afterCopyStrings
        copyFailed: I18n.translate 'js.modules.coupons.copy_failed', afterCopyStrings
        printThisCouponAndVisitMerchant: I18n.translate 'js.modules.coupons.print_this_coupon_and_visit_merchant',
          merchantName: @place.placeName
        noCodeRequiredInstore: I18n.translate 'js.modules.coupons.no_code_required_instore',
          merchantName: @place.placeName
        useOnlineOrInstore: I18n.translate 'js.modules.coupons.use_online_or_instore',
          startUseOnline: '<button class="btn-cta btn-small use-online">'
          endUseOnline: '</button>'
          startOr: '<span class="use-online-or-instore">'
          endOr: '</span>'
          startUseInstore: '<button class="btn-cta btn-small use-instore">'
          endUseInstore: '</button>'


    redemptionHtml = redemptionTemplate.render redemptionTemplateData

    expandedCardTemplateData = _.extend basicTemplateData,
      redemptionHtml: redemptionHtml,
      sharingHtml: sharingHtml,
      displayType:
        onlinePromoCode: @coupon.displayType is 'online_promo_code'
        onlineSale: @coupon.displayType is 'online_sale'
        instoreSale: @coupon.displayType is 'instore_sale'
        onlineInStorePromoCode: @coupon.displayType is 'online_instore_promo_code'
        onlineInstoreSale: @coupon.displayType is 'online_instore_sale'
        mobileDownloadSale: @coupon.displayType is 'mobile_download_sale'
      strings:
        offerEnds: if not @coupon.endsOn?.length > 0 then null else I18n.translate 'js.modules.coupons.offer_ends',
          date: @coupon.endsOn

    html = templates.expandedCard.render expandedCardTemplateData
    @$contentExpanded.html html
    @$contentExpanded.slideDown 'fast', =>
      @initZeroClipboard()
      @initSharingButtons()

  collapse: =>
    # The way ZeroClipBoard works is by destroying the main window object, not the instance.
    # This is because there can only be one ZeroClipboard element on the page at any time.
    ZeroClipboard?.destroy()
    @$description.addClass 'should-truncate-singleline'
    @$contentExpanded.slideUp 'fast', =>
      @$el.removeClass 'is-expanded'
      @isExpanded = false

  promoCodeCopied: ->
    @$el.find('.copy-promo-code').addClass 'hidden'
    @$el.find('.coupon-after-copy').removeClass 'hidden'
    @$el.find('.coupon-before-copy').addClass 'hidden'

  promoCodeCopyFailed: ->
    @$el.find('.copy-promo-code').addClass 'hidden'
    @$el.find('.coupon-copy-failed').removeClass 'hidden'

  initZeroClipboard: ->
    @zeroClipboard = new ZeroClipboard @$el.find('.copy-promo-code')

    @zeroClipboard.on 'complete', =>
      @promoCodeCopied()
      ZeroClipboard?.destroy()

    @zeroClipboard.on 'wrongflash noflash', =>
      ZeroClipboard?.destroy()
      @initHtml5Clipboard()

  initHtml5Clipboard: ->
    @$el.on 'click', '.copy-promo-code', =>
      successful = @copyToClipboard @coupon.promoCode
      return @promoCodeCopied() if successful
      return @promoCodeCopyFailed()

  copyToClipboard: (text) ->
    # based on http://stackoverflow.com/a/30810322/694086

    textArea = document.createElement 'textarea'
    textArea.style.position = 'fixed'
    textArea.style.top = 0
    textArea.style.left = 0
    textArea.style.width = '2em'
    textArea.style.height = '2em'
    textArea.style.padding = 0
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = text

    document.body.appendChild textArea
    textArea.select()

    try
      successful = document.execCommand 'copy'
    catch err
      successful = false

    document.body.removeChild textArea

    return successful

  initSharingButtons: ->
    slug = window.location.pathname.replace '/biz/', ''

    options =
      el: @$el.find '.offer-sharing'
      merchantPage:
        permalink: slug
        queryParams:
          coupon_id: @coupon.id
        merchantName: @place.placeName
        twitterBody:  I18n.t 'js.modules.coupons.sharing.twitter.body',
          merchantName: @place.placeName
        emailSubject: I18n.t 'js.modules.coupons.sharing.email.subject',
          merchantName: @place.placeName
        emailBody: I18n.t 'js.modules.coupons.sharing.email.body',
          merchantName: @place.placeName
        campaign: 'UserReferral_mpp_coupons'

    new Groupon.SharingButtons(options)

  checkQueryString: ->
    # if the URL includes ?coupon_id=id, we move this card to the top
    couponId = getQueryStringByName 'coupon_id'
    return unless couponId is @coupon.id

    $offerCards = $ '#multiple-offers .offer-cards'
    $offerCards.prepend @$el

    duration = 800
    $('html, body').animate {
      scrollTop: $offerCards.offset().top - 10
    }, duration, =>
      @expand()
